import { render, staticRenderFns } from "./EditBlog.vue?vue&type=template&id=19d82a53&scoped=true"
import script from "./EditBlog.vue?vue&type=script&lang=js"
export * from "./EditBlog.vue?vue&type=script&lang=js"
import style0 from "./EditBlog.vue?vue&type=style&index=0&id=19d82a53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d82a53",
  null
  
)

export default component.exports